document.addEventListener('DOMContentLoaded', () => {
  const TOOLTIP_HOLD_MS = 900;

  document.querySelectorAll('.card__inner .quick-add .quick-add__submit').forEach((btn) => {
    let hideTimer = null;

    const show = () => {
      clearTimeout(hideTimer);
      btn.classList.add('quick-add__submit--show-tooltip');
    };
    const scheduleHide = () => {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        btn.classList.remove('quick-add__submit--show-tooltip');
      }, TOOLTIP_HOLD_MS);
    };

    btn.addEventListener('touchstart', show, { passive: true });
    btn.addEventListener('touchend', scheduleHide, { passive: true });
    btn.addEventListener('touchcancel', scheduleHide, { passive: true });
  });
});
